import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import DashboardView from '@/components/panel/DashboardView'
import Dashboard from '@/components/panel/Dashboard'
import Console from '@/components/panel/Console'
import FileManager from '@/components/panel/FileManager'
import Backups from '@/components/panel/Backups'
import BrowsePlugins from '@/components/panel/BrowsePlugins'
import InstalledPlugins from '@/components/panel/InstalledPlugins'
import Versions from '@/components/panel/Versions'
import Settings from '@/components/panel/Settings'
import Addons from '@/components/panel/Addons'

import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import Recover from '@/components/auth/Recover'

import Management from '@/components/Management'
import Servers from '@/components/management/Servers'
import Configure from '@/components/management/Configure'

import Support from '@/components/management/support/Support'
import CreateTicket from '@/components/management/support/CreateTicket'
import ViewTicket from '@/components/management/support/ViewTicket'

import Billing from '@/components/management/billing/Billing'
import ViewInvoice from '@/components/management/billing/ViewInvoice'
import Checkout from '@/components/management/billing/Checkout'
import Pricing from '@/components/management/billing/Pricing'

Vue.use(Router)

function authenticated (to, from, next) {
  if (store.state.authenticated || localStorage.getItem('auth_token') !== null) {
    // or however you store your logged in state
    next() // allow to enter route
  } else {
    next('/auth/login') // go to '/login';
  }
}

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '',
      component: Management,
      children: [
        {
          name: 'servers',
          path: '',
          component: Servers,
          beforeEnter: authenticated
        },
        {
          name: 'configure',
          path: '/servers/configure',
          component: Configure,
          beforeEnter: authenticated
        },
        {
          name: 'support',
          path: '/support',
          component: Support,
          beforeEnter: authenticated
        },
        {
          name: 'create-ticket',
          path: '/support/ticket/create',
          component: CreateTicket,
          beforeEnter: authenticated
        },
        {
          name: 'view-ticket',
          path: '/support/ticket/:id/view',
          component: ViewTicket,
          beforeEnter: authenticated
        },
        {
          name: 'billing',
          path: '/billing',
          component: Billing,
          beforeEnter: authenticated
        },
        {
          name: 'view-invoice',
          path: '/billing/invoice/:id/view',
          component: ViewInvoice,
          beforeEnter: authenticated
        },
        {
          name: 'checkout',
          path: '/billing/cart/checkout',
          component: Checkout,
          beforeEnter: authenticated
        },
        {
          name: 'pricing',
          path: '/billing/pricing',
          component: Pricing,
          beforeEnter: authenticated
        }
      ]
    },
    {
      name: 'login',
      path: '/auth/login',
      component: Login
    },
    {
      name: 'register',
      path: '/auth/register',
      component: Register
    },
    {
      name: 'recover',
      path: '/auth/recover',
      component: Recover
    },
    {
      path: '/server/:id',
      name: 'DashboardView',
      component: DashboardView,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: Dashboard
        },
        {
          name: 'console',
          path: 'console',
          component: Console
        },
        {
          name: 'manager',
          path: 'files/manager',
          component: FileManager
        },
        {
          name: 'backups',
          path: 'files/backups',
          component: Backups
        },
        {
          name: 'browse-plugins',
          path: 'plugins/browse',
          component: BrowsePlugins
        },
        {
          name: 'installed-plugins',
          path: 'plugins/installed',
          component: InstalledPlugins
        },
        {
          name: 'versions',
          path: 'versions',
          component: Versions
        },
        {
          name: 'settings',
          path: 'settings',
          component: Settings
        },
        {
          name: 'addons',
          path: 'addons',
          component: Addons
        }
      ],
      beforeEnter: authenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js